import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel, SimulatorConteinerButton, SimulatorSubSelectOficeLabelBlack
} from './styles';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { SessionContext, LiquidacionPagosContext } from '../../../store';
import { Form, FormFooter, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { DefaultLargeButton, SecondaryLargeButton, UploadFileButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice, handleChangeIdentification } from '../../../helpers/price';
import { getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { Container, ContainerSinMargen, SimulatorSelectOfficeImg, SimulatorSelectOficeLabel, SimulatorSelectOficeLabelBlack } from '../styles';
import SelectOfficeImg from '../../../assets/images/SelectOfficeImg.svg'
import InputPhone from '../../../components/InputPhone';
import { default as HabeasDataSenderTypes } from '../../../store/HabeasDataSender/types';
import { habeasDataSenderSteps, pagosSteps } from '../../../helpers/enum';
import { getDominioCorreo, getDominioCorreoConfirmados } from '../../../services/dominioCorreo';
import FormTemplate from "../../../components/FormTemplate";
import { identificationType } from '../../../helpers/enum';
import { getIdentificationTypes } from '../../../services/calculator';
import InputDefaultOnlyText from '../../../components/InputDefaultOnlyText';
import { enviarNotificacionCedulaHabeasData } from '../../../services/habeasData';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import { useHistory } from 'react-router-dom';
import SearchFieldCategories from '../../../components/SearchFieldCategories';
import RadioButtonForm from '../../../components/RadioButtonForm';
import { AttachDocumentButton } from '../../AttachDocumentsPage/styles';
import { FiArrowUp } from 'react-icons/fi';
import AttachDocumentsItem from '../../AttachDocumentsPage/AttachDocumentItem';
import UploadDocuments from '../../../components/UploadDocuments';
import { getConsultarProceso, postAceptarSettlement, postEnviarPlanilla } from '../../../services/pagos';
import LoaderOneMinute from '../../../components/LoaderOneMinute';
import ModalAction from '../../../components/ModalAction';
import InputPassword from '../../../components/InputPassword';

const PaymentSheet = ({ setActiveStep, setLastStep }) => {
  const { liquidacionPagos, setLiquidacionPagos } = useContext(LiquidacionPagosContext);
  const history = useHistory();
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [showModalNotificacion, setShowModalNotificacion] = useState(false);
  const [messageModalNotificacion, setMessageModalNotificacion] = useState('');
  const [showModalNotificacionError, setShowModalNotificacionError] = useState(false);
  const [showModalAdvertencia, setShowModalAdvertencia] = useState(false);
  const [showModalInfoWarning, setShowModalInfoWarning] = useState(false);
  const [titleWarning, setTitleWarning] = useState('');
  const [messageWarning, setMessageWarning] = useState('');
  const [isLoadingOneMinute, setIsLoadingOneMinute] = useState(false);
  const [showModalAceptado, setShowModalAceptado] = useState(false);
  const [entePagador, setEntePagador] = useState({});
  const [planillaFile, setPlanillaFile] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [operador, setOperador] = useState({});
  const [operadores, setOperadores] = useState([
    { id: -99, nombre: "Seleccionar..." },
    { id: 1, nombre: "Aportes en linea" },
    { id: 2, nombre: "SOI" },
    { id: 3, nombre: "Mi planilla" },
    { id: 4, nombre: "Asopagos" },
    { id: 5, nombre: "Simple" },
    { id: 6, nombre: "Arus (Enlace operativo)" }
  ]);
  const [showOperadores, setShowOperadores] = useState(false);
  const [usuario, setUsuario] = useState(false);
  const [contrasenia, setcontrasenia] = useState(false);
  const [showWarningModal2, setShowWarningModal2] = useState(false);
  const [showModalCode0, setShowModalCode0] = useState(false);
  const [showModalCode1, setShowModalCode1] = useState(false);
  const [showModalCode2, setShowModalCode2] = useState(false);
  const [showModalCode3, setShowModalCode3] = useState(false);
  const [modalCodeDescription, setModalCodeDescription] = useState('');
  const [uploadedDocuments, setUploadedDocuments] = useState([]);

  const MAX_ADDITIONAL_DOCUMENTS = 4;

  async function calculateData(formDataa) {
    try {
      setIsLoading(true);
      if (entePagador.value == 'ASESOR') {
        const req = new FormData();
        if (planillaFile) {
          req.append('archivo1', planillaFile, planillaFile.name);
        }else{
          setShowModalInfoError(true)
          setIsLoading(false);
          return
        }
        uploadedDocuments.forEach((doc) => {
          req.append('archivos', doc.file, doc.file.name);
        });
        const responseEnvioArchivo = await postEnviarPlanilla(liquidacionPagos.settlement.identificacion, req)
      }

      let data = {
        acceptance: true,
        asesorPaga: entePagador.value == 'ASESOR',
        dateTime: new Date().toISOString().slice(0, 19),
        documentId: "CC",
        documentNumber: liquidacionPagos.settlement.identificacion,
        idAsesor: session.idAsesor,
        koaPaga: entePagador.value == 'EXCELCREDIT',
        user: formDataa.usuario,
        password: formDataa.contrasenia,
        operadora: operador?.nombre,
        comment: liquidacionPagos.settlement?.comentario
      }
      const response2 = await postAceptarSettlement(data);
      if (entePagador.value == 'EXCELCREDIT') {
        let procesoDataa = {
          dateTime: new Date().toISOString().slice(0, 19)
        }
        localStorage.setItem("procesoData", JSON.stringify(procesoDataa));
        setMessageModalNotificacion('Gracias por cargar tus datos')
        setShowModalNotificacion(true)
      }

      setIsLoading(false);
      if (entePagador.value == 'ASESOR') {
        setIsLoadingOneMinute(true);
        await new Promise(resolve => setTimeout(resolve, 60000));
        const response = await getConsultarProceso(liquidacionPagos.settlement.identificacion);
        localStorage.setItem("procesoData", JSON.stringify(response.data));
        showModalCode(response);
        setIsLoadingOneMinute(false);
      }

    } catch (error) {
      setIsLoading(false);
      setIsLoadingOneMinute(false);
    }

  }

  async function initializeStateComponent() {
    try {
      const datos = JSON.parse(localStorage.getItem("procesoData"));
      console.log(datos)
      if (datos?.dateTime) {
        const fechaDatos = new Date(datos.dateTime);
        const ahora = new Date();

        const mismoMes = fechaDatos.getFullYear() === ahora.getFullYear() && fechaDatos.getMonth() === ahora.getMonth();

        if (mismoMes) {
          if (liquidacionPagos.settlement.aceptaLiquidacion && liquidacionPagos.settlement.asesorPaga && datos?.estado == 2) {
            setShowModalAceptado(true);
            return;
          }

          if (liquidacionPagos.settlement.aceptaLiquidacion && liquidacionPagos.settlement.koaPaga) {
            setShowModalAceptado(true);
            return;
          }
        }
      }

      if (liquidacionPagos.settlement.aceptaLiquidacion && liquidacionPagos.settlement.asesorPaga) {
        const response = await getConsultarProceso(liquidacionPagos.settlement.identificacion);
        showModalCode(response);
      }

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  function showModalCode(response) {
    setModalCodeDescription(response.data.mensaje)
    if (response.data.estado == 0) {
      setShowModalCode0(true)
      setIsLoadingOneMinute(false);
    } else if (response.data.estado == 1) {
      setShowModalCode1(true)
      setIsLoadingOneMinute(false);
    } else if (response.data.estado == 2) {
      setShowModalCode2(true)
      setIsLoadingOneMinute(false);
    } else if (response.data.estado == 3) {
      setShowModalCode3(true)
      setIsLoadingOneMinute(false);
    }
  }

  function setBackStep() {
    setActiveStep(pagosSteps.LIQUIDACION);
  }

  function setEntidadPagadora(radio) {
    if (radio.value == 'EXCELCREDIT') {
      setShowWarningModal(true);
    } else if (radio.value == 'ASESOR') {
      setShowWarningModal2(true);
    }
  }

  const handlePlanillaFileChange = (newFile) => {
    setPlanillaFile(newFile);
  };

  function setEnteExcel() {
    setEntePagador({ label: 'ExcelCredit paga planilla', value: 'EXCELCREDIT' })
    setShowWarningModal(false)
  }

  function setEnteAsesor() {
    setEntePagador({ label: 'Asesor paga planilla', value: 'ASESOR' })
    setShowWarningModal2(false)
  }

  const handleRemoveAdditionalDocument = (idToRemove) => {
    setUploadedDocuments((prevDocs) => prevDocs.filter((doc) => doc.id !== idToRemove));
  };

  const handleAdditionalDocumentChange = (newFile) => {
    if (newFile && uploadedDocuments.length < MAX_ADDITIONAL_DOCUMENTS) {
      const newDocument = {
        id: Date.now() + Math.random(),
        file: newFile,
      };
      setUploadedDocuments((prevDocs) => [...prevDocs, newDocument]);
    } else if (uploadedDocuments.length >= MAX_ADDITIONAL_DOCUMENTS) {
      setMessageModalNotificacion(`Solo puedes subir un máximo de ${MAX_ADDITIONAL_DOCUMENTS} documentos adicionales.`);
      setShowModalNotificacionError(true);
    }
  };

  const isAdditionalUploaderDisabled = uploadedDocuments.length >= MAX_ADDITIONAL_DOCUMENTS;
  return (
    <div style={{ padding: '40px', paddingTop: '0px' }}>
      <FormTemplate
        idForm="basic-data-step-page"
        activeStep="2/2"
        stepLabel="Planilla de pago"
      >
        <Form onSubmit={handleSubmit(calculateData)}>
          <SimulatorSelectOficeLabel style={{}}>Sube los soportes de planilla</SimulatorSelectOficeLabel>
          <div>
            <RadioButtonForm
              label="Aportes seguridad social"
              setIdentificationRadioChecked={setEntidadPagadora}
              selected={entePagador.value}
              name="origenCodigo"
              id="origenCodigo"
              radios={[
                { label: 'ExcelCredit paga planilla', value: 'EXCELCREDIT', tooltip: true, TooltipContent: 'Si seleccionas esta opción la compañia paga por ti la planilla' },
                { label: 'Asesor paga planilla', value: 'ASESOR', tooltip: true, TooltipContent: 'Si seleccionas esta opción deberás cargar la planilla pagada por el asesor' }
              ]}
              register={register({ required: "Este dato es obligatorio" })}
            />
            {entePagador.value == 'EXCELCREDIT' &&
              <>
                <FormRow col='2'>
                  <Select
                    error={errors.operador}
                    setShow={setShowOperadores}
                    show={showOperadores}
                    defaultValue={operador?.nombre}
                    setSelected={setOperador}
                    list={operadores}
                    placeholder="Seleccionar..."
                    label="Operadores de pago planilla"
                    name="operador"
                    id="operador"
                    register={register({ required: "Este dato es obligatorio" })}
                  />
                </FormRow>
                <FormRow col='2'>
                  <Controller
                    as={InputDefault}
                    control={control}
                    label='Usuario'
                    name="usuario"
                    id="usuario"
                    error={errors.usuario}
                    value={usuario}
                    register={register({ required: "Este dato es obligatorio" })} />
                </FormRow>
                <FormRow col='2'>
                  <Controller
                    as={InputPassword}
                    control={control}
                    label='Contraseña'
                    name="contrasenia"
                    id="contrasenia"
                    error={errors.contrasenia}
                    value={contrasenia}
                    register={register({ required: "Este dato es obligatorio" })} />
                </FormRow>
              </>}
            {entePagador.value == 'ASESOR' &&
              <div>
                <UploadDocuments
                  title="Planilla seguridad social"
                  paragraph="Máximo 10MB, formato en PDF"
                  inputlabel="archivo-planilla-principal"
                  onFileChange={handlePlanillaFileChange}
                  fileName={planillaFile?.name}
                  onRemoveFile={() => setPlanillaFile(null)}
                />

                {!isAdditionalUploaderDisabled && (
                  <UploadDocuments
                    key={uploadedDocuments.length}
                    title="Soportes adicionales"
                    paragraph="Máximo 10MB, formato en PDF"
                    inputlabel={`archivo-adicional-carga`}
                    onFileChange={handleAdditionalDocumentChange}
                    isAdder={true}
                  />
                )}
                {isAdditionalUploaderDisabled && (
                  <p style={{ color: colors.textPrimary, marginTop: '15px', fontWeight: 'bold' }}>
                    Has alcanzado el límite de {MAX_ADDITIONAL_DOCUMENTS} documentos adicionales.
                  </p>
                )}

                {uploadedDocuments.map((docItem,index) => (
                  <UploadDocuments
                    key={docItem.id}
                    title={`Soporte adicional ${index + 1}`}
                    paragraph="Máximo 10MB, formato en PDF"
                    inputlabel={`uploaded-doc-display-${docItem.id}`}
                    fileName={docItem.file.name}
                    onRemoveFile={() => handleRemoveAdditionalDocument(docItem.id)}
                    isRemovable={true}
                  />
                ))}
              </div>}
          </div>
          <FormFooter justify="space-between">
            <DefaultLargeButton type="button" onClick={() => setBackStep()}>Volver</DefaultLargeButton>
            <SecondaryLargeButton type="submit">Enviar</SecondaryLargeButton>
          </FormFooter>
          {isLoading && <Loader></Loader>}
          {isLoadingOneMinute && <LoaderOneMinute></LoaderOneMinute>}
        </Form>
        <ModalInfo
          open={showModalInfoError}
          setShowModal={setShowModalInfoError}
          title={titleError}
          description={<div>
            El documento <b>Planilla seguridad social</b> es obligatorio para continuar con el proceso.
          </div>}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalActionSendIdValidation
          open={showModalNotificacion}
          actionFunctionDownButton={() => history.push('/admin/dashboard')}
          actionLabelFunctionDownButton="Continuar"
          description={messageModalNotificacion}
          bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
          backgroundIcon={colors.textHyperlink} />
        <ModalActionSendIdValidation
          open={showModalNotificacionError}
          actionFunctionDownButton={() => setShowModalNotificacionError(false)}
          actionLabelFunctionDownButton="Continuar"
          description={messageModalNotificacion}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
          backgroundIcon={colors.bgDanger} />
        <ModalActionSendIdValidation
          open={showModalAdvertencia}
          actionFunctionDownButton={() => setShowModalAdvertencia(false)}
          actionLabelFunctionDownButton="Continuar"
          description='Para asegurarnos de que toda la información en nuestro sistema es correcta, por favor, confirma los datos del cliente.'
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
          backgroundIcon={colors.yellow} />
        <ModalInfo
          open={showModalInfoWarning}
          setShowModal={setShowModalInfoWarning}
          title={titleWarning}
          description={messageWarning}
          backgroundIcon={colors.bgTertiary}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalAction
          open={showWarningModal}
          setShowModal={setShowWarningModal}
          actionFunctionDownButton={() => setShowWarningModal(false)}
          actionFunctionUpButton={() => setEnteExcel()}
          title="¿Estas seguro que deseas que ExcelCredit pague por ti la planilla?"
          actionLabelFunctionDownButton="NO"
          actionLabelFunctionUpButton="SI"
          backgroundIcon={colors.textHyperlink}
          bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
        <ModalAction
          open={showWarningModal2}
          setShowModal={setShowWarningModal2}
          actionFunctionDownButton={() => setShowWarningModal2(false)}
          actionFunctionUpButton={() => setEnteAsesor()}
          title="¿Estas seguro que deseas pagar tu planilla?"
          actionLabelFunctionDownButton="NO"
          actionLabelFunctionUpButton="SI"
          backgroundIcon={colors.textHyperlink}
          bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
        <ModalAction
          open={showModalCode0}
          setShowModal={setShowModalCode0}
          actionFunctionDownButton={() => setShowModalCode0(false)}
          actionFunctionUpButton={() => setShowModalCode0(false)}
          description={modalCodeDescription}
          actionLabelFunctionUpButton="Subir"
          actionLabelFunctionDownButton="Cancelar"
          backgroundIcon={colors.yellow}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        <ModalAction
          open={showModalCode1}
          setShowModal={setShowModalCode1}
          actionFunctionUpButton={() => setShowModalCode1(false)}
          description={modalCodeDescription}
          actionLabelFunctionUpButton="Cerrar"
          backgroundIcon={colors.yellow}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        <ModalAction
          open={showModalCode2}
          setShowModal={setShowModalCode2}
          actionFunctionUpButton={() => history.push('/admin/dashboard')}
          description={modalCodeDescription}
          actionLabelFunctionUpButton="Aceptar"
          backgroundIcon={colors.textHyperlink}
          bodyIcon={<BsCheck size={32} color={colors.white} />} />
        <ModalAction
          open={showModalCode3}
          setShowModal={setShowModalCode3}
          actionFunctionDownButton={() => setShowModalCode3(false)}
          description={modalCodeDescription}
          actionLabelFunctionDownButton="Cerrar"
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        <ModalAction
          open={showModalAceptado}
          actionFunctionUpButton={() => setBackStep()}
          description='Durante este mes ya has enviado los datos para pago.'
          actionLabelFunctionUpButton="Aceptar"
          backgroundIcon={colors.darkGray}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />

      </FormTemplate>

    </div>
  )
}

export default PaymentSheet;